import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZcLoaderComponent } from './zc-loader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
  ],
  declarations: [ZcLoaderComponent],
  exports: [ZcLoaderComponent]
})
export class ZcLoaderModule { }
